import { inject, Injectable } from '@angular/core';
import {
  ReleaseCalendarModalComponent
} from "../components/modals/release-calendar-modal/release-calendar-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { ReleaseCalendarResult, ReleaseCalendarSelectedOptions } from "../types/release-calendar-types";
import { Observable } from "rxjs";
import { CloseModalReason } from "../../../../core/types/modal.types";

@Injectable({
  providedIn: 'root'
})
export class ReleaseCalendarPageModalsService {
  private dialog: MatDialog = inject(MatDialog);

  public openReleaseCalendarModal(params: ReleaseCalendarSelectedOptions | null): Observable<ReleaseCalendarResult | CloseModalReason | undefined> {
    const dialogRef = this.dialog.open(ReleaseCalendarModalComponent, {
      width: '400px',
      data: {
        data: params
      }
    });

    return dialogRef.afterClosed();
  }

  public isReleaseCalendarResult(result: ReleaseCalendarResult | CloseModalReason | undefined): result is ReleaseCalendarResult {
    return !!result && typeof result === 'object' && 'data' in result && 'releaseCalendarSelectedOptions' in result;
  }
}
